module.exports = __webpack_public_path__ + "20250721160708/img/kong.57fecc40.png";